/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsLangEditorViewModel } from "../types/CourseDocumentsLangEditorViewModel.ts";

export const courseDocumentsLangEditorViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe(
      "Cultura do conteúdo. Aceita apenas pt-BR, en-US e es-ES, e não pode repetir na mesma requisição. É a chave usada para localizar o conteúdo existente, porque a coluna numérica de idioma do legado é inconsistente na base.",
    )
    .nullish(),
  documentName: z
    .string()
    .describe(
      "Nome do documento no idioma, máximo de 250 caracteres. Quando vazio, assume o nome geral do documento. Opcional.",
    )
    .nullish(),
  documentHtml: z
    .string()
    .describe(
      "Conteúdo da declaração no idioma. Envie HTML-encoded, no mesmo formato devolvido pelo GET, porque é assim que o renderizador da declaração espera recebê-lo: a API grava o valor exatamente como recebido, sem codificar nem decodificar. Ignorado quando a declaração é do tipo arquivo. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CourseDocumentsLangEditorViewModel>;
